import { MessageType } from '@doveit/bricks';
import { PerformanceRating } from '../../../providers/api/dtos';

export const configByCr: Record<'cr2' | 'cr3', {
  helperContent: string,
  chartCaption: string,
}> = {
  cr2: {
    chartCaption: 'CR2 annuale',
    helperContent: 'Il CR2 è il rapporto tra numero di mandati e numero di valutazioni. Il CR2 medio degli agenti di Dove.it è {AVG_CR}%.',
  },
  cr3: {
    chartCaption: 'CR3 annuale',
    helperContent: 'Il CR3 è il rapporto tra numero di vendite e numero di mandati. Il CR3 medio degli agenti di Dove.it è {AVG_CR}%.',
  },
};

export const configByCrPerformanceRating: Record<PerformanceRating | 'NOT_DEFINED', {
  variant: MessageType,
  title?: string,
}> = {
  CRITICAL: {
    variant: 'critical',
    title: '**{CR}** del team molto sotto la media ({CR_PERFORMANCE}%)',
  },
  BELOW_EXPECTATIONS: {
    variant: 'warning',
    title: '**{CR}** del team sotto la media ({CR_PERFORMANCE}%)',
  },
  NEARLY_ON_TRACK: {
    variant: 'info',
    title: '**{CR}** del team quasi nella media ({CR_PERFORMANCE}%)',
  },
  ON_TRACK: {
    variant: 'info',
    title: '**{CR}** del team nella media ({CR_PERFORMANCE}%)',
  },
  ABOVE_EXPECTATIONS: {
    variant: 'success',
    title: '**{CR}** del team sopra la media ({CR_PERFORMANCE}%)',
  },
  NOT_DEFINED: {
    variant: 'neutral',
    title: '**{CR}** del team non disponibile',
  },
};
